import type { ListSuppliersParams } from '@amarantos/api-client'
import { z } from 'zod/v3'

const baseSuppliersSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	search: z.string().default(''),
	sort: z.enum(['name', 'created_at']).default('created_at'),
})

const drawerSearchStateSchema = z.union([
	z.object({
		mode: z.literal('create'),
		supplierId: z.undefined().optional(),
	}),
	z.object({
		mode: z.literal('edit'),
		supplierId: z.coerce.number().int().positive(),
	}),
	z.object({
		mode: z.undefined().optional(),
		supplierId: z.undefined().optional(),
	}),
])

export const suppliersSearchSchema = baseSuppliersSearchSchema.and(drawerSearchStateSchema)

export type SuppliersSearch = z.infer<typeof suppliersSearchSchema>

export function toListSuppliersParams(search: SuppliersSearch): ListSuppliersParams {
	return {
		page: search.page,
		per_page: search.perPage,
		search: search.search.length > 0 ? search.search : undefined,
		sort: search.sort,
	}
}
